module.exports = __webpack_public_path__ + "static/media/icn_arrow_down.c492647c.svg";